import {Component, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {selectAudioTracksFromState} from '../shared/stores/root-store/selectors/video.selector';
import VideoState from '../shared/stores/root-store/video.state';
import AudioTrackModel from '../../models/audio-track.model';
import {AudioService} from '../shared/services/audio.service';

@Component({
    selector: 'eocm-audio',
    templateUrl: './audio.component.html',
    styleUrls: ['./audio.component.scss']
})
export class AudioComponent implements OnInit {

    useAudioContext = false;
    audioContext: AudioContext = null;
    audioList: Array<AudioTrackModel> = [];
    unlockedAudioContext = false;

    constructor(
        private store: Store<{ video: VideoState }>,
        private audio: AudioService
    ) {
        this.useAudioContext = audio.shouldUseAudioContext();
    }

    ngOnInit() {
        if (this.useAudioContext) {
            this.audioContext = this.audio.getAudioContext();
        }

        this.store.select(selectAudioTracksFromState).subscribe(audioTracks => {
            this.audioList = audioTracks;
        });
    }
}
